
let sold = document.querySelectorAll('#sold-group input'),
    sold_checked;

for (let el of sold) {
  // console.log(el);
  el.addEventListener('click', uncheck)
}


function uncheck() {

  if(sold_checked != this){
  	sold_checked = this
  }else{
    this.checked = false
  	sold_checked = null
  }
}
